/* import libraries */
import { useState, useEffect } from "react";

/* import components */
import Card from "react-bootstrap/Card";

const BadgeFill = (props) => {
    const [textColor, setTextColor] = useState("#ffffff");
    const [bgColor, setBgColor] = useState("#F5F5F5");

    useEffect(() => {
        switch (props.title) {
            case "Closed":
                setBgColor("#6D6F71");
                setTextColor("#ffffff");
                break;
            case "1 Pax":
                setBgColor(props.serviceType === "RydeFLASH" ? "#E93864" : "#42B626");
                setTextColor("#ffffff");
                break;
            case "2 Pax":
                setBgColor(props.serviceType === "RydeFLASH" ? "#E93864" : "#42B626");
                setTextColor("#ffffff");
                break;
            case "3 Pax":
                setBgColor(props.serviceType === "RydeFLASH" ? "#E93864" : "#42B626");
                setTextColor("#ffffff");
                break;
            case "4 Pax":
                setBgColor(props.serviceType === "RydeFLASH" ? "#E93864" : "#42B626");
                setTextColor("#ffffff");
                break;
            default:
                setBgColor("#F5F5F5");
                setTextColor("#404042");
                break;
        }
    }, [props.title]);

    return (
        <>
            <Card className="rydetype-card topics font-semibold"
                style={{ borderColor: bgColor, 
                    color: textColor, 
                    backgroundColor: bgColor, 
                    margin: props.type === 'ticket' ? "-2px 10px 0 0" : "" }}>
                {props.title}
            </Card>
        </>
    );
}

export default BadgeFill;